import styled from 'styled-components';

export const Content = styled.div`
  gap: 4px;
  align-self: stretch;
  padding: var(--content-padding);
  overflow: auto;
  height: calc(var(--content-height) - var(--page-header-height) - var(--page-padding-height));
`;

export const Wrapper = styled.div`
  height: calc(var(--content-height));
`;
